import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ActionBarContentTab = ({ buttons }) => (
  <>
    {buttons.map((item, index) => (
      <div key={index}>
        <button
          className={"actionbar-btn actionbar-btn-horizontal"}
          onClick={item?.onClick}
        >
          <span className={"actionbar-btn-inner-horizontal"}>
            <FontAwesomeIcon
              icon={item?.icon}
              className="actionbar-btn-icon"
            />
            <span className="actionbar-btn-text">
              {item?.text.replace("Add ", "")}
            </span>
          </span>
        </button>
      </div>
    ))}
  </>
);